import { Component, OnInit, OnDestroy } from "@angular/core";
import { ProductService } from "src/app/shared/services/product.service";
import { ActivatedRoute, RouterEvent } from "@angular/router";
import { Product } from "src/app/shared/models/product";
import { ShoppingCartService } from "src/app/shared/services/shopping-cart.service";
import { DataService } from "src/app/shared/services/data.service";
import { Subscription } from "rxjs";
@Component({
  selector: "app-products",
  templateUrl: "./products.component.html",
  styleUrls: ["./products.component.scss"],
})
export class ProductsComponent implements OnInit, OnDestroy {
  products: any = [];
  filteredProducts: any[] = [];
  productLoader: any = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  category: string;
  categoryId: number;
  searchString: string;
  sliderLoaded: boolean = false;
  productsSubscription: Subscription;
  routeSubscription: Subscription;
  searchSubscription: Subscription;
  slides: any = [];
  cart: Product[];
  noProduct: boolean = false;
  showPagination: boolean = false;

  pageNo: number = 1;
  currentPage: number = 1;
  itemsPerPage: number = 15;
  itemsOnPage: number;
  totalCount: number = 50;

  merchantCurrency: string;
  merchant:any = {};

  constructor(
    private productService: ProductService,
    private shoppinCartService: ShoppingCartService,
    private route: ActivatedRoute,
    private dataService: DataService,
    private cartService: ShoppingCartService
  ) {}

  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    autoplay: true,
  };

  slickInit(e) {
    this.sliderLoaded = true;
  }

  pageChanged(event) {
    this.filteredProducts = [];
    this.pageNo = event.page;

    //  //console.log(this.searchValue);
    // if (this.searchValue != null){
    //   this.search();
    // }else

    this.populateProduct();
  }

  breakpoint(e) {
    // console.log('breakpoint');
  }
  ngOnInit() {
    this.getSliders();
    this.populateProduct();
    this.getMerchantCurrency();
  }
  calcVatPrice(items: any = [], result: any = []) {
    for (let i = 0; i < items.length; i++) {
      this.filteredProducts[i].stockQuantity = +items[i].quantity;
      if (this.filteredProducts[i].has_vat === true) {
        this.filteredProducts[i].vatPrice =
          +items[i].price + +items[i].vat_amount;
      } else {
        this.filteredProducts[i].vatPrice = items[i].price;
      }
    }
  }
  private applyFilter() {
    this.productService
      .getProductByCategory(this.categoryId)
      .subscribe((data) => {
        this.filteredProducts = data.data;
        // console.log(data);
        this.totalCount = data.total_count;

        this.showPagination =
          this.totalCount > this.itemsPerPage ? true : false;
        // this.itemsPerPage = this.filteredProducts.length < this.itemsPerPage ? this.filteredProducts.length : this.itemsPerPage;

        this.calcVatPrice(this.filteredProducts);

        this.noProduct = this.filteredProducts.length === 0 ? true : false;
      });
    // this.filteredProducts = this.category
    //   ? this.products.filter(p => p.category === this.category)
    //   : this.products;
  }

  private searchProduct() {
    this.searchSubscription = this.productService
      .searchAll(this.searchString)
      .subscribe((product) => {
        this.filteredProducts = product.data;
        this.noProduct = this.filteredProducts.length === 0 ? true : false;
      });
  }

  getSliders() {
    this.productService.getBanners().subscribe(
      (data) => {
        this.slides = data.data;
        // console.log(this.slides);
      },
      (err) => {}
    );
  }

  populateProduct() {
    this.productsSubscription = this.productService
      .getProducts(this.pageNo, this.itemsPerPage)
      .subscribe(
        (data) => {
          console.log(data);

          this.products = data.data;
          this.totalCount = data.total_count;

          this.showPagination =
            this.totalCount > this.itemsPerPage ? true : false;

          for (let i = 0; i < this.products.length; i++) {
            this.products[i].stockQuantity = +this.products[i].quantity;
            if (this.products[i].has_vat === true) {
              this.products[i].vatPrice =
                +this.products[i].price + +this.products[i].vat_amount;
              // this.products[i].vatPrice = +this.products[i].price ;
            } else {
              this.products[i].vatPrice = this.products[i].price;
            }
          }

          this.dataService.productsSubject.next(this.products);

          this.routeSubscription = this.route.queryParamMap.subscribe(
            (param) => {
              this.category = param.get("category");
              this.categoryId = +param.get("qid");
              this.searchString = param.get("searchString");

              if (this.searchString) {
                this.searchProduct();
              } else if (this.category) {
                this.applyFilter();
              } else {
                this.filteredProducts = this.products;
              }
            }
          );
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getMerchantCurrency() {
    this.dataService.merchantDetails.subscribe(data =>{
      if(data && Object.keys(data||{}).length ){
        this.merchant = data;
        this.merchantCurrency = this.merchant.merchantCurrency;
        localStorage.setItem("currency", this.merchantCurrency);

      }
    });
  }

  ngOnDestroy() {
    // this.productsSubscription.unsubscribe();
    // this.searchSubscription.unsubscribe();
    // this.routeSubscription.unsubscribe();
  }
}
